<template>
    <index-table
        :cols="[
            {
                value: 'name',
                label: 'Name',
                searchable: true,
                sortable: true,
            },
            {
                value: 'feature',
                label: 'Feature',
                searchable: true,
                sortable: true,
            },
            {
                value: 'description',
                label: 'Description',
                searchable: true,
                sortable: false,
            },
            {
                value: 'is_premium',
                label: 'Premium',
                filter: 'convertBoolean',
                searchable: true,
                sortable: false,
            },
            {
                value: 'permissions',
                label: 'API Permissions',
                display: 'name',
                searchable: false,
                sortable: false,
            },
        ]"
        :title="'Mobile Features'"
        :model="'mobile-features'"
        :createText="'Create Mobile Feature'"
        :options="['editable', 'deletable']"
        data-test-id="features-table"
    />
</template>

<script>
import IndexTable from '@/components/IndexTable/index.vue'

export default {
    components: {
        IndexTable,
    },
}
</script>
